import { render, staticRenderFns } from "./userm-typeahead.vue?vue&type=template&id=0544ef9c&"
import script from "./userm-typeahead.vue?vue&type=script&lang=js&"
export * from "./userm-typeahead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hugomarcelino/projects/cob/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0544ef9c')) {
      api.createRecord('0544ef9c', component.options)
    } else {
      api.reload('0544ef9c', component.options)
    }
    module.hot.accept("./userm-typeahead.vue?vue&type=template&id=0544ef9c&", function () {
      api.rerender('0544ef9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/recordm/fields/userm-typeahead.vue"
export default component.exports